import notifications from '@store/notifications/notifications.reducer';

const appNotifications = notifications('appNotifications');

export default appNotifications;
